/**
 * Created by henian.xu on 2019/9/12.
 * 权限 (menuResource)
 */
import { VueConstructor } from 'vue';

let powerMap: { [k: string]: boolean } | null = null;

// 添加权限
export function addPower(list: string[] = [], isClear = true): void {
    if (!powerMap || isClear) {
        powerMap = {};
    }
    list.reduce((pre, cur) => {
        pre[cur] = true;
        return pre;
    }, powerMap);
}

export function removePower(list: string[] = []): void {
    if (!powerMap) return;
    list.forEach(key => {
        delete powerMap![key];
    });
}

interface PowerFunction {
    (value: string[], bitAnd: boolean): boolean;
    addPower: typeof addPower;
}

export const hasPower: PowerFunction = (value: string[], bitAnd: boolean): boolean => {
    if (!powerMap || powerMap['*']) return true;
    let result = false;
    // eslint-disable-next-line no-cond-assign
    for (let i = 0, item; (item = value[i]); i += 1) {
        result = powerMap[item];
        if (!result) {
            const itemArr = item.split(':');
            const itemLen = itemArr.length - 1;
            for (let n = 0; n < itemLen; n += 1) {
                itemArr.length -= 1;
                const key = `${itemArr.join(':')}*`;
                result = powerMap[key];
                if (result) break;
            }
        }
        // 处理关系
        if (bitAnd) {
            if (!result) break;
        } else if (result) break;
    }
    return result;
};
hasPower.addPower = addPower;

export default (vue: VueConstructor): void => {
    Object.defineProperty(vue, '$power', {
        get(): PowerFunction {
            return hasPower;
        },
    });
    Object.defineProperty(vue.prototype, '$power', {
        get(): PowerFunction {
            return hasPower;
        },
    });
};

declare module 'vue/types/vue' {
    export interface Vue {
        readonly $power?: PowerFunction;
    }
}
